<template>
    <div class="Ask">
        <Box :title="title">
            <div class="infoBox">
                <Field type="manufacturer" name="EquipmentDictionaries"
                    @manuconfirm="data.SBMCBH=arguments[0].a,data.SBMC=arguments[0].b" title="设备名称" :action="true"
                    :text="data.SBMC" @input="value=>manuInputValue(value,1)" :SelectionAndInput='true' />

                <Field title="设备别名" placeholder="请输入" :text="data.SBBM" @onMessage="x=>data.SBBM=x" />
                <Field title="数量" type="number" name='digit' :action="true" placeholder="请输入" :text="data.CGSL"
                    @onMessage="x=>{data.CGSL=x,data.CGJE=Number(x)*Number(data.CGDJ);}" />
                <Field title="单价(元)" type="number" name='number' :action="true" placeholder="请输入" :text="data.CGDJ"
                    @onMessage="x=>{data.CGDJ=x;data.CGJE=Number(x)*Number(data.CGSL);}" />

                <Field title="总金额" type="text" :text="data.CGJE?Number(data.CGJE).toFixed(2):'系统自动计算'" />
                <Field title="规格型号" placeholder="请输入" :text="data.SBGG" @onMessage="x=>data.SBGG=x" />
            </div>
            <div class="infoBox">
                <Field title="单位" type='input' placeholder="请输入" :text="data.SBDW" @onMessage="x=>data.SBDW=x" />
                <Field title="生产厂家" type="manufacturer" name="supplier" :SelectionAndInput='true' :text="data.SCQYMC"
                    @manuconfirm="data.TJSCQY=arguments[0].a,data.SCQYMC=arguments[0].b"
                    @input="value=>manuInputValue(value,2)" />

                <Field title="供应商" name="manufacturer" :text="data.GYSMC" :SelectionAndInput='true'
                    @manuconfirm="data.TJGYS=arguments[0].a,data.GYSMC=arguments[0].b" type="manufacturer"
                    @input="value=>manuInputValue(value,3)" />

                <Field title="品牌" name="brand" :text="data.PPMC" :SelectionAndInput='true'
                    @manuconfirm="data.TJBrand=arguments[0].a,data.PPMC=arguments[0].b" type="manufacturer"
                    @input="value=>manuInputValue(value,4)" />

                <Field title="购置类别" type='popup' @confirm="data.GZLBMC=arguments[0],data.GZLB=arguments[0]==='报废更新'?'01':arguments[0]==='添置'?'02':'03'
                " :data="['报废更新','添置','新增']" placeholder="请选择" :text="data.GZLBMC" />
            </div>
            <div class="infoBox GC">
                <p class="title">是否国产</p>
                <div>
                    <div v-for="item in [{id:'0',name:'国产'},{id:'1',name:'进口'},{id:'2',name:'未知'}]"
                        :class="data.SFJK === item.id ? 'action' : ''"
                        @click="data.SFJK = item.id;data.SFJKMC=item.name">{{item.name}}</div>
                    <!-- @onMessage="value => uploadData.SFJKBH = value" -->
                </div>
            </div>
        </Box>
        <Footer v-if="!(this.$route.params.SHZT=='1'||this.$route.params.SHZT=='2')" button="保存" @change="save" />
    </div>
</template>

<script>
    // import {
    //     Cell
    // } from 'vant'
    import Box from '../../components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import Footer from '../../components/footer/footer'
    export default {
        name: 'AskAdd',
        data() {
            return {
                title: this.$route.params.item ? '修改明细' : '添加明细',
                data: this.$route.params.item ? this.$route.params.item : {
                    SFJK: '0',
                    SFJKMC: '国产',
                    CGJE: 0
                },
            }
        },
        mounted() {
        },
        methods: {
            save() {
                if (this.$verification(this.data, [{
                        id: 'SBMC',
                        name: '设备不能为空,请输入或选择!'
                    }, {
                        id: 'CGSL',
                        name: '请输入数量!'
                    }, {
                        id: 'CGDJ',
                        name: '请输入单价!'
                    }])) {
                    this.$Bus.$emit('updateAskRows', this.data);
                    this.$router.back();
                }
            },
            manuInputValue(obj, index) {
                switch (index) {
                    case 1: //设备
                        this.data.SBMCBH = obj;
                        this.data.SBMC = obj;
                        break;
                    case 2: //生产厂家
                        this.data.TJSCQY = obj;
                        this.data.SCQYMC = obj;
                        break;
                    case 3: //供应商
                        this.data.TJGYS = obj;
                        this.data.GYSMC = obj;
                        break;
                    case 4: //品牌
                        this.data.TJBrand = obj;
                        this.data.PPMC = obj;
                        break;
                }
            }
        },
        components: {
            Box,
            Field,
            Footer,
           // [Cell.name]: Cell
        }
    }
</script>

<style scoped lang="scss">
    .Ask {
        padding-bottom: 112px;
    }

    .infoBox {
        padding: 0 30px;

        .title {
            font-weight: 400;
        }
    }

    .GC {
        padding: 34px 30px;

        &>div {
            display: flex;
            align-items: center;

            div {
                width: 198px;
                height: 76px;
                border-radius: 8px;
                text-align: center;
                line-height: 76px;
                background: #F3F3F3;
                color: #858585;
                font-size: 30px;
                margin-right: 30px;

                &:last-child {
                    margin-right: 0;
                }
            }

            .action {
                color: #fff;
                background: $THEME-COLOR;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/askAdd/askAdd.vue